import { render, staticRenderFns } from "./DeclarationOfInterests.vue?vue&type=template&id=19f710c2&scoped=true"
import script from "./DeclarationOfInterests.vue?vue&type=script&lang=js"
export * from "./DeclarationOfInterests.vue?vue&type=script&lang=js"
import style0 from "./DeclarationOfInterests.vue?vue&type=style&index=0&id=19f710c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f710c2",
  null
  
)

export default component.exports